// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableColumnTitles_headRow__nSCK5 {
  height: 60px;
  color: #000;
}
.TableColumnTitles_thTitle__oLSvi {
  border-bottom: 1px solid #606060;
  /* min-width: 180px; */
  padding: 0 8px;
  position: relative;
  width: 100%;
}
.TableColumnTitles_codeTh__FCgy3 {
  width: 110px !important;
  max-width: 110px !important;
}
.TableColumnTitles_statusTd__1a1Hn {
  width: 130px !important;
  max-width: 130px !important;
}
.TableColumnTitles_thView__zL08I {
  border-bottom: 1px solid #606060;
  width: 64px;
  /* padding-inline-end: 10px; */
}
.TableColumnTitles_counterTitle__-rcd9 {
  border-bottom: 1px solid #606060;
  max-width: 50px;
  width: 50px;
  /* padding: 0 8px; */
  padding-inline-start: 12px;
  padding-inline-end: 8px;
}
.TableColumnTitles_checkboxTitle__YqxWL {
  border-bottom: 1px solid #606060;
  text-align: start;
  /* min-width: 30px;
  max-width: 60px; */
  width: 50px;
  padding: 0 12px;
}
.TableColumnTitles_thTitle__oLSvi:hover .TableColumnTitles_sortIcon__ykNCU {
  opacity: 0.5;
  background-color: #d3d3d3;
}
.TableColumnTitles_rtlThSort__rXt11 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* transform: translateX(17px); */
  /* padding-inline-end: 24px; */
}
.TableColumnTitles_ltrThSort__yltK5 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row-reverse;
  transform: translateX(10px);
}
.TableColumnTitles_sortIcon__ykNCU {
  transition: all 0.3s ease-out !important ;
  transform: rotate(0);
  margin-inline-start: 5px;
  cursor: pointer;
  opacity: 0;
  border-radius: 50%;
}
.TableColumnTitles_sortIconAsc__SSpKF {
  transform: rotate(0);
  fill: #128300;
  color: #128300;
  opacity: 1;
}
.TableColumnTitles_sortIconDesc__4AMiH {
  transform: rotate(180deg);
  fill: red;
  color: red;
  opacity: 1;
}
.TableColumnTitles_thSortTxt__xWCAG {
  transition: all 0.3s ease-out !important ;
  width: -moz-fit-content;
  width: fit-content;
  max-width: calc(100% - 26px);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.TableColumnTitles_emptyThTitle__kAT82 {
  border-bottom: 1px solid #606060;
  min-width: 8px;
}
.TableColumnTitles_selectAllInput__luw0I {
  width: 16px;
  height: 16px;
}
.TableColumnTitles_resizeHandle__ntLAB {
  width: 16px;
  cursor: col-resize;
  background: transparent;
  height: 100%;
  position: absolute;
  /* right: 0; */
  top: 0;
  z-index: 1;
  margin-inline-start: calc(50% - 17px);
  touch-action: none;
}
.TableColumnTitles_resizeHandle__ntLAB::after {
  content: "";
  width: 1px;
  cursor: col-resize;
  background: rgb(212, 212, 212);
  height: calc(100% - 16px);
  position: absolute;
  /* right: 0; */
  top: 0;
  z-index: 1;
  margin-inline-start: calc(50% - 4px);
  margin-block: 8px;
}
/* .headRow > *:nth-last-child(2) .resizeHandle {
  display: none;
} */
`, "",{"version":3,"sources":["webpack://./src/Components/NewTable/TableColumnTitles/TableColumnTitles.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB;oBACkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,cAAc;EACd,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;AACA;EACE,yCAAyC;EACzC,uBAAkB;EAAlB,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,UAAU;EACV,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,UAAU;EACV,oCAAoC;EACpC,iBAAiB;AACnB;AACA;;GAEG","sourcesContent":[".headRow {\r\n  height: 60px;\r\n  color: #000;\r\n}\r\n.thTitle {\r\n  border-bottom: 1px solid #606060;\r\n  /* min-width: 180px; */\r\n  padding: 0 8px;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n.codeTh {\r\n  width: 110px !important;\r\n  max-width: 110px !important;\r\n}\r\n.statusTd {\r\n  width: 130px !important;\r\n  max-width: 130px !important;\r\n}\r\n.thView {\r\n  border-bottom: 1px solid #606060;\r\n  width: 64px;\r\n  /* padding-inline-end: 10px; */\r\n}\r\n.counterTitle {\r\n  border-bottom: 1px solid #606060;\r\n  max-width: 50px;\r\n  width: 50px;\r\n  /* padding: 0 8px; */\r\n  padding-inline-start: 12px;\r\n  padding-inline-end: 8px;\r\n}\r\n.checkboxTitle {\r\n  border-bottom: 1px solid #606060;\r\n  text-align: start;\r\n  /* min-width: 30px;\r\n  max-width: 60px; */\r\n  width: 50px;\r\n  padding: 0 12px;\r\n}\r\n.thTitle:hover .sortIcon {\r\n  opacity: 0.5;\r\n  background-color: #d3d3d3;\r\n}\r\n.rtlThSort {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  /* transform: translateX(17px); */\r\n  /* padding-inline-end: 24px; */\r\n}\r\n.ltrThSort {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  flex-direction: row-reverse;\r\n  transform: translateX(10px);\r\n}\r\n.sortIcon {\r\n  transition: all 0.3s ease-out !important ;\r\n  transform: rotate(0);\r\n  margin-inline-start: 5px;\r\n  cursor: pointer;\r\n  opacity: 0;\r\n  border-radius: 50%;\r\n}\r\n.sortIconAsc {\r\n  transform: rotate(0);\r\n  fill: #128300;\r\n  color: #128300;\r\n  opacity: 1;\r\n}\r\n.sortIconDesc {\r\n  transform: rotate(180deg);\r\n  fill: red;\r\n  color: red;\r\n  opacity: 1;\r\n}\r\n.thSortTxt {\r\n  transition: all 0.3s ease-out !important ;\r\n  width: fit-content;\r\n  max-width: calc(100% - 26px);\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n.emptyThTitle {\r\n  border-bottom: 1px solid #606060;\r\n  min-width: 8px;\r\n}\r\n.selectAllInput {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n.resizeHandle {\r\n  width: 16px;\r\n  cursor: col-resize;\r\n  background: transparent;\r\n  height: 100%;\r\n  position: absolute;\r\n  /* right: 0; */\r\n  top: 0;\r\n  z-index: 1;\r\n  margin-inline-start: calc(50% - 17px);\r\n  touch-action: none;\r\n}\r\n.resizeHandle::after {\r\n  content: \"\";\r\n  width: 1px;\r\n  cursor: col-resize;\r\n  background: rgb(212, 212, 212);\r\n  height: calc(100% - 16px);\r\n  position: absolute;\r\n  /* right: 0; */\r\n  top: 0;\r\n  z-index: 1;\r\n  margin-inline-start: calc(50% - 4px);\r\n  margin-block: 8px;\r\n}\r\n/* .headRow > *:nth-last-child(2) .resizeHandle {\r\n  display: none;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headRow": `TableColumnTitles_headRow__nSCK5`,
	"thTitle": `TableColumnTitles_thTitle__oLSvi`,
	"codeTh": `TableColumnTitles_codeTh__FCgy3`,
	"statusTd": `TableColumnTitles_statusTd__1a1Hn`,
	"thView": `TableColumnTitles_thView__zL08I`,
	"counterTitle": `TableColumnTitles_counterTitle__-rcd9`,
	"checkboxTitle": `TableColumnTitles_checkboxTitle__YqxWL`,
	"sortIcon": `TableColumnTitles_sortIcon__ykNCU`,
	"rtlThSort": `TableColumnTitles_rtlThSort__rXt11`,
	"ltrThSort": `TableColumnTitles_ltrThSort__yltK5`,
	"sortIconAsc": `TableColumnTitles_sortIconAsc__SSpKF`,
	"sortIconDesc": `TableColumnTitles_sortIconDesc__4AMiH`,
	"thSortTxt": `TableColumnTitles_thSortTxt__xWCAG`,
	"emptyThTitle": `TableColumnTitles_emptyThTitle__kAT82`,
	"selectAllInput": `TableColumnTitles_selectAllInput__luw0I`,
	"resizeHandle": `TableColumnTitles_resizeHandle__ntLAB`
};
export default ___CSS_LOADER_EXPORT___;
